  <footer class="page-footer">
    <div class="footer-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-sm-6">
            <!-- <p class="mb-0 text-muted">ColoredStrategies 2020</p> -->
          </div>
          <div class="col-sm-6 d-none d-sm-block">
            <ul class="breadcrumb pt-0 pr-0 float-right">
              <li class="breadcrumb-item mb-0">
                <a href="/privacy" target="_blank" class="btn-link">Privacy Policy</a>
              </li>
              <li class="breadcrumb-item mb-0">
                <a href="/tos" target="_blank" class="btn-link">Terms of Service</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
